/* these are the identifiers used for scores coming from Neon, they will replace HnaCategories.js at some point */
/* eslint-disable sort-keys-fix/sort-keys-fix */
const NeonHnaCategories = {
    IntellectualCapabilities: {
        ABSTRACT_INTELLIGENCE: "abstractAbility",
        ABSTRACT_INTELLIGENCE_CORRECT: "abstractAbilityTotalCorrect",
        ABSTRACT_INTELLIGENCE_INCORRECT: "abstractAbilityTotalIncorrect",
        ABSTRACT_INTELLIGENCE_OMITTED: "abstractAbilityTotalOmitted",
        ABSTRACT_INTELLIGENCE_RETEST: "abstractAbilityRetest",
        ABSTRACT_INTELLIGENCE_RETEST_TOTAL_CORRECT: "abstractAbilityRetestTotalCorrect",
        ABSTRACT_INTELLIGENCE_RETEST_TOTAL_INCORRECT: "abstractAbilityRetestTotalIncorrect",
        ABSTRACT_INTELLIGENCE_RETEST_TOTAL_OMITTED: "abstractAbilityRetestTotalOmitted",
        ABSTRACT_INTELLIGENCE_LABEL: "abstractAbilityLabel",
        ABSTRACT_INTELLIGENCE_RETEST_LABEL: "abstractAbilityRetestLabel",
        CRITICAL_THINKING: "criticalThinking",
        CRITICAL_THINKING_COUNT: "criticalThinkingCount",
        CRITICAL_THINKING_CORRECT: "criticalThinkingTotalCorrect",
        CRITICAL_THINKING_INCORRECT: "criticalThinkingTotalIncorrect",
        CRITICAL_THINKING_OMITTED: "criticalThinkingTotalOmitted",
        CRITICAL_THINKING_ATTEMPTED: "criticalThinkingAttempted",
        VERBAL_INTELLIGENCE: "verbalAbility",
        VERBAL_INTELLIGENCE_REGULAR: "verbalAbilityRegular",
        VERBAL_INTELLIGENCE_CORRECT: "verbalIntelligenceTotalCorrect",
        VERBAL_INTELLIGENCE_INCORRECT: "verbalIntelligenceTotalIncorrect",
        VERBAL_INTELLIGENCE_OMITTED: "verbalIntelligenceTotalOmitted",
        VERBAL_INTELLIGENCE_RETEST_TOTAL_CORRECT: "verbalIntelligenceRetestTotalCorrect",
        VERBAL_INTELLIGENCE_RETEST_TOTAL_INCORRECT: "verbalIntelligenceRetestTotalIncorrect",
        VERBAL_INTELLIGENCE_RETEST_TOTAL_OMITTED: "verbalIntelligenceRetestTotalOmitted",
        VERBAL_INTELLIGENCE_RETEST: "verbalIntelligenceRetest",
        VERBAL_INTELLIGENCE_LABEL: "verbalIntelligenceLabel",
        VERBAL_INTELLIGENCE_LABEL_RETEST: "verbalIntelligenceLabelRetest",
        VERBAL_INTELLIGENCE_RETEST_FLAG: "verbalIntelligenceRetestFlag",
        NUMERIC_INTELLIGENCE: "numericalAbility",
        NUMERIC_INTELLIGENCE_CORRECT: "numericIntelligenceTotalCorrect",
        NUMERIC_INTELLIGENCE_INCORRECT: "numericIntelligenceTotalIncorrect",
        NUMERIC_INTELLIGENCE_OMITTED: "numericIntelligenceTotalOmitted",
        NUMERIC_INTELLIGENCE_RETEST: "numericalAbilityRetest",
        NUMERIC_INTELLIGENCE_RETEST_TOTAL_CORRECT: "numericIntelligenceRetestTotalCorrect",
        NUMERIC_INTELLIGENCE_RETEST_TOTAL_INCORRECT: "numericIntelligenceRetestTotalIncorrect",
        NUMERIC_INTELLIGENCE_RETEST_TOTAL_OMITTED: "numericIntelligenceRetestTotalOmitted",
        NUMERIC_INTELLIGENCE_LABEL: "numericIntelligenceLabel",
        NUMERIC_INTELLIGENCE_LABEL_RETEST: "numericIntelligenceRetestLabel",
        TOTAL_INTELLIGENCE: "overallAbility",
        ABSTRACT_INTELLIGENCE_RETEST_FLAG: "abstractIntelligenceRetestFlag",
        NUMERIC_INTELLIGENCE_RETEST_FLAG: "numericIntelligenceRetestFlag",
        GMAT_ABILITY: "gMatAbility",
        GMAT_ABILITY_CORRECT: "gMatAbilityTotalCorrect",
        GMAT_ABILITY_INCORRECT: "gMatAbilityTotalIncorrect",
        GMAT_ABILITY_OMITTED: "gMatAbilityTotalOmitted",
        GMAT_ABILITY_RETEST: "gMatAbilityRetest",
        GMAT_ABILITY_RETEST_FLAG: "gMatAbilityRetestFlag",
        GMAT_ABILITY_RETEST_TOTAL_CORRECT: "gMatAbilityRetestTotalCorrect",
        GMAT_ABILITY_RETEST_TOTAL_INCORRECT: "gMatAbilityRetestTotalIncorrect",
        GMAT_ABILITY_RETEST_TOTAL_OMITTED: "gMatAbilityRetestTotalOmitted",
        GMAT_ABILITY_LABEL: "gMatAbilityLabel",
        GMAT_ABILITY_LABEL_RETEST: "gMatAbilityRetestLabel",
        GMAT_ABILITY_MBO1: "gMatAbilityMBO1",
        GMAT_ABILITY_MBO2: "gMatAbilityMBO2",
        GMAT_ABILITY_MBO3: "gMatAbilityMBO3",
        GMAT_ABILITY_MBO4: "gMatAbilityMBO4",
    },
    Personality: {
        EMOTIONAL_STABILITY: "Emotionele.stabiliteit",
        EXTRAVERSION: "Extraversie",
        CONSCIENTIOUSNESS: "Conscientieusheid",
        OPEN_MINDNESS: "Openheid.van.geest",
        MILDNESS: "Vriendelijkheid",
    },
    PersonalityEmotionalStability: {
        RELATIONAL_STRESS_TOLERANCE: "Relationele.stressbestendigheid",
        DOWN_TO_EARTH: "Nuchterheid",
        TASK_RELATED_STRESS_TOLERANCE: "Taakgerelateerde.stressbestendigheid",
        OPTIMISM: "Optimisme",
    },
    PersonalityExtraversion: {
        SOCIABILITY: "Sociabiliteit",
        DOMINANCE: "Dominantie",
        ENERGY: "Energie",
    },
    PersonalityConscientiousness: {
        WORKING_SYSTEMATICALLY: "Systematisch.werken",
        RESPONSIBILITY: "Verantwoordelijkheid",
        SELF_DISCIPLINE: "Zelfdiscipline",
    },
    PersonalityOpenMindness: {
        IMAGINATION: "Verbeelding",
        INDEPENDENT_THINKING: "Onafhankelijk.denken",
    },
    PersonalityFriendliness: {
        HELPFULNESS: "Behulpzaamheid",
        TRUST: "Vertrouwen",
    },
    PersonalityPlus: {
        MATERIALISM: "Materialisme",
        PRIDE: "Trots",
        SINCERITY: "Oprechtheid",
        INDULGENCE: "Inschikkelijkheid",
        CHANGE_ORIENTATED: "Veranderingsgericht",
    },
    PersonalityBuildingDocks: {
        CUNNING: "intermediateReportCunning",
        ECCENTRIC: "intermediateReportEccentric",
        FOCUS_ON_SELF_INTEREST: "intermediateReportFocusOnSelfInterest",
        GREGARIOUS: "intermediateReportGregarious",
        PROUD: "intermediateReportProud",
        SELF_STARTING: "intermediateReportSelfStarting",
        STATUS_DRIVEN: "intermediateReportStatusDriven",
        SENSITIVE: "intermediateReportSensitive",
    },
    RiskIndicationBuildingDocks: {
        RISK_INDICATION: "intermediateReportRiskIndication",
    },
    WorkingStyles: {
        SUCCESS_ACHIEVEMENT: "Extrinsieke.prestatiemotivatie",
        QUALITY_ACHIEVEMENT: "Intrinsieke.prestatiemotivatie",
        DEVELOPMENT_ORIENTATION: "Ontwikkelingsgericht",
        PERFORMANCE_UNCERTAINTY: "Negatieve.faalangst",
        LOOKING_FOR_CHALLENGES: "Positieve.faalangst",
        DECISIVENESS: "Doortastend",
        GOAL_ORIENTED: "Doelgericht",
        TAKING_RISKS: "Risicobereid",
    },
    Motives: {
        PERFORMANCE_MOTIVATION: "Behoefte.aan.prestatie",
        NEED_TO_INFLUENCE: "Behoefte.aan.macht",
        NEED_FOR_ACCEPTANCE: "Behoefte.aan.affiliatie",
        NEED_FOR_AUTONOMY: "Behoefte.aan.autonomie",
    },
    InfluencingStyles: {
        MANIPULATIVE: "Manipulatief",
        STRAIGHTFORWARD: "Rechtdoorzee",
        ASSERTIVE: "Assertief",
        ANTICIPATING: "Berekenend",
    },
    ValuesQuestionnaire: {
        SUPPORT_AND_RECOGNITION: "Steun.en.Erkenning",
        CONFORMITY: "Conformeren",
        INDEPENDENCE: "Onafhankelijkheid",
        ALTRUISM: "Altruisme",
        LEADERSHIP: "Leiderschap",
        STRUCTURE: "Ordelijkheid",
        VARIETY: "Variatie",
    },
    ToBe: {
        TO_BE_GO_GETTER: "zij-1aanpa",
        TO_BE_CONTROLLER: "zij-2contr",
        TO_BE_INNOVATOR: "zij-3innov",
        TO_BE_EXPERT: "zij-4exper",
        TO_BE_COORDINATOR: "zij-5coord",
        TO_BE_INSPIRATOR: "zij-6inspi",
        TO_BE_CONNECTOR: "zij-7verbi",
        TO_BE_ENTREPRENEUR: "zij-8onder",
    },
    ToWant: {
        TO_WANT_GO_GETTER: "wil-1aanpa",
        TO_WANT_CONTROLLER: "wil-2contr",
        TO_WANT_INNOVATOR: "wil-3innov",
        TO_WANT_EXPERT: "wil-4exper",
        TO_WANT_COORDINATOR: "wil-5coord",
        TO_WANT_INSPIRATOR: "wil-6inspi",
        TO_WANT_CONNECTOR: "wil-7verbi",
        TO_WANT_ENTREPRENEUR: "wil-8onder",
    },
    Fit: {
        FIT_MATCH: "fit-match",
    },
};

export default NeonHnaCategories;
